import { AxiosResponse } from 'axios'
import { Simulation } from 'types/simulation'
import { api } from '@services/api'
import { CalculateSimulation, CalculateSimulationDto } from './types'

export const save = (
  simulation: Omit<Simulation, 'id' | 'created_at' | 'updated_at'>
): Promise<AxiosResponse<Simulation>> => api.post('/simulations', simulation)

export const calculate = (params: CalculateSimulation) =>
  api.post<CalculateSimulationDto>('/simulations/calculate', { params })

export const SimulationsApi = {
  save,
  calculate
}
